(() => {
  const UTM_KEYS = ['source', 'medium', 'campaign'];

  const collect = (root, selector) => {
    const nodes = [];
    if (root?.matches?.(selector)) nodes.push(root);
    if (root?.querySelectorAll) nodes.push(...root.querySelectorAll(selector));
    return nodes;
  };

  const initTracking = (root = document) => {
    const params = new URLSearchParams(window.location.search);
    collect(root, '[data-bm-sell-page]').forEach((section) => {
      UTM_KEYS.forEach((key) => {
        const field = section.querySelector(`[data-bm-utm-${key}]`);
        if (field) field.value = params.get(`utm_${key}`) || '';
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initTracking(), { once: true });
  } else {
    initTracking();
  }

  document.addEventListener('shopify:section:load', (event) => initTracking(event.target));
})();
